import { useTranslation } from '@lt/localization';
import React from 'react';
import styled from 'styled-components';
import type { TouristsState } from 'src/store/tourists/slice';
import TouristInfo from './components/TouristInfo';
import { TEST_ID_MOBILE_SUMMARY_TOURIST_INFO } from './constants';

type Props = {
  tourists?: TouristsState[];
  onClick: (touristNumber: number) => void;
  isTouristsConfirmed: boolean;
};

const TouristsSummary = (props: Props) => {
  const { tourists, isTouristsConfirmed, onClick } = props;

  const { t } = useTranslation();

  if (!tourists || !isTouristsConfirmed) return null;

  return (
    <Wrapper>
      <Title>{t('checkout.summary.tourists.title')}</Title>
      <Tourists>
        {tourists.map((tourist, idx) => (
          <TouristInfo
            testId={`${TEST_ID_MOBILE_SUMMARY_TOURIST_INFO}-${idx}`}
            onClick={() => onClick(idx)}
            key={tourist.passport_number}
            tourist={tourist}
          />
        ))}
      </Tourists>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 8px;
`;

const Tourists = styled.div`
  > * + * {
    margin-top: 8px;
  }
`;

const Title = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #919499;
`;

export default TouristsSummary;
